import { formatNumber } from '~/utils/formatNumber';
import getCurrencySymbol from '~/utils/getCurrencySymbol';

export const metrics = ['Revenue', 'Ad Requests', 'Impressions'];

export const metricConfig = {
  Revenue: {
    chipLabel: 'Revenue',
    chipColor: '#20B2AA',
    barColor: '#20B2AA',
  },
  'Ad Requests': {
    chipLabel: 'Ad Requests',
    chipColor: '#2F80ED',
    barColor: '#2F80ED',
  },
  Impressions: {
    chipLabel: 'Impressions',
    chipColor: '#F58A07',
    barColor: '#F58A07',
  },
};

export function getSourcesChartOption({ sources, selectedMetric }) {
  const selectedMetricLabel = metricConfig[selectedMetric]?.chipLabel ?? selectedMetric;
  const xAxisLabels = sources.map(item => item.name);
  const seriesData = sources.map(item => Number(item.metrics?.[selectedMetric] ?? 0));
  const currencySymbol = getCurrencySymbol();
  const formatTooltipValue = (value, metric) => {
    const formattedValue = Number(value ?? 0).toLocaleString();
    return metric === 'Revenue' ? `${currencySymbol} ${formattedValue}` : formattedValue;
  };
  const getTooltipMarker = metric =>
    `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:8px;height:8px;background-color:${metricConfig[metric].barColor};"></span>`;

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: params => {
        const [firstPoint] = Array.isArray(params) ? params : [params];
        if (!firstPoint) {
          return '';
        }

        const source = sources.find(item => item.name === firstPoint.axisValue);
        if (!source) {
          return '';
        }

        return [
          `${firstPoint.axisValue}`,
          `${getTooltipMarker('Revenue')} ${formatTooltipValue(source.metrics?.Revenue, 'Revenue')}`,
          `${getTooltipMarker('Ad Requests')} ${formatTooltipValue(source.metrics?.['Ad Requests'], 'Ad Requests')}`,
          `${getTooltipMarker('Impressions')} ${formatTooltipValue(source.metrics?.Impressions, 'Impressions')}`,
        ].join('<br/>');
      },
      valueFormatter: value => {
        return formatTooltipValue(value, selectedMetric);
      },
    },
    grid: {
      top: 16,
      right: 12,
      bottom: 42,
      left: 56,
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: xAxisLabels,
      axisTick: { show: false },
      axisLine: {
        lineStyle: { color: '#323232', width: 1.2 },
      },
      axisLabel: {
        color: '#212121',
        fontSize: 14,
        margin: 14,
        interval: 0,
        lineHeight: 18,
        width: 80,
        overflow: 'break',
      },
    },
    yAxis: {
      type: 'value',
      min: 0,
      splitLine: { show: false },
      axisTick: { show: false },
      axisLine: { show: false },
      axisLabel: {
        color: '#2d2d2d',
        fontSize: 14,
        fontWeight: 500,
        formatter: formatNumber,
      },
    },
    series: [
      {
        name: selectedMetricLabel,
        type: 'bar',
        data: seriesData,
        barWidth: '72%',
        itemStyle: {
          color: metricConfig[selectedMetric].barColor,
          borderRadius: [4, 4, 0, 0],
        },
      },
    ],
  };
}
